import React from 'react';
import Styled from 'styled-components';

export const Content = Styled.div`
	font-family: ${({theme}) => theme.fontFamily};
	font-size: 12px;
	letter-spacing: 0.5px;
	font-weight: 400;

	display: flex;
	flex-direction: row;
	align-items: center;
	padding: 2px 4px 2px 4px;
`;

const TagContainer = Styled.div`
	position: relative;
	width: fit-content;	
	height: fit-content;	
	
	border-radius: 4px;
	background-color: #E5F4FF;
	color: #393946;
	
	display: inline-block;
`;

export const BetaTag = () => {
	return (
		<TagContainer>
			<Content>Beta</Content>
		</TagContainer>
	);
};
